//
// GlobalLegendVisibility.js
// gtl
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */

var GlobalLegendVisibility = {
    OFF:0,
    AUTO:1
};
export default GlobalLegendVisibility;
